import { useToastContext } from 'components/providers/ToastProvider';

import type { Notification } from './types';

export const useToast = () => {
    const { broadcastToast, clearToast, toast } = useToastContext();

    return {
        broadcastToast,
        setToastData: (value: Notification | null) => {
            if (value === null) {
                clearToast();
            } else {
                broadcastToast(value);
            }
        },
        toastData: () => toast
    };
};

export default useToast;
